import React from "react";

/**
 * Tabs shown in Data Requests
 * States: All, In Progress, Completed or Merged
 */

export default function RequestTabs({ toggleState, toggleTab }) {
  return (
    <div className="bloc-tabs-topic">
      <div className="bloc">
        <div
          className={
            toggleState === "All"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("All");
          }}
        >
          <p>All</p>
        </div>
        <div
          className={
            toggleState === "In Progress"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("In Progress");
          }}
        >
          <p>In Progress</p>
        </div>
        <div
          className={
            toggleState === "Completed"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("Completed");
          }}
        >
          <p>Completed</p>
        </div>
        <div
          className={
            toggleState === "Merged"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("Merged");
          }}
        >
          <p>Merged</p>
        </div>
      </div>
    </div>
  );
}
